import SectionOrgGroupsPage from './SectionOrgGroupsPage'


export default SectionOrgGroupsPage
